import React from 'react'
import { ILoanerRecord, IMinimalDevice, TABLE_HEADERS } from '../../LoanerVehicles'

import classNames from 'classnames'
import { CircularProgress } from '@mui/material'

import styles from '../../LoanerVehicles.module.scss'
import ActiveLoanerRow from './ActiveLoanerRow'

interface IActiveLoanersTableProps {
  loaners: ILoanerRecord[]
  onSave: (loanerId: string) => void
  onEdit: (loanerId: string) => void
  onDelete: (loanerId: string) => void
  onFieldChange: (
    loanerId: string,
    field: keyof ILoanerRecord,
    value: string
  ) => void
  onLoanerVehicleSelect: (loanerId: string, device: IMinimalDevice) => void
  availableDevices: IMinimalDevice[]
  isTableHidden: boolean
  isLoading: boolean
}

const ActiveLoanersTable = ({
  loaners,
  onSave,
  onEdit,
  onDelete,
  onFieldChange,
  onLoanerVehicleSelect,
  availableDevices,
  isTableHidden,
  isLoading,
}: IActiveLoanersTableProps) => {
  return (
    <div
      className={classNames({
        [styles.hidden]: isTableHidden,
        [styles.activeTable]: !isTableHidden,
      })}
    >
      <div className={styles.tableContainer}>
        <table>
          <thead>
            <tr>
              {TABLE_HEADERS.map((header) => (
                <th key={header}>{header}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {loaners.map((loaner) => {
              return (
                <ActiveLoanerRow
                  key={loaner.id}
                  loaner={loaner}
                  onSave={onSave}
                  onEdit={onEdit}
                  onDelete={onDelete}
                  onFieldChange={onFieldChange}
                  onLoanerVehicleSelect={onLoanerVehicleSelect}
                  availableDevices={availableDevices}
                />
              );
            })}

            {/* No data */}
            {loaners.length === 0 && (
              <tr>
                <td colSpan={TABLE_HEADERS.length} className={styles.noData}>
                  {isLoading ? (
                    <CircularProgress color="inherit" />
                  ) : (
                    'No active loaner vehicles. Click "Add new" to assign one.'
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ActiveLoanersTable
